import {createSlice} from "@reduxjs/toolkit";
import {RequestFiltersTableModel} from "../../model/tableFilters/RequestFiltersTable.model";

const initialState: { value:RequestFiltersTableModel|null } = {value:null}

export const DeadManagementFiltersSlice = createSlice({
    name: 'DeadManagementFilters',
    initialState: initialState,
    reducers:{
        saveDeadManagementFilters: (state, action) => {
            state.value  = action.payload;
        },
        clearFilterDeadManagementFilters:(state, action)=>{
            if(state?.value){
                //state.value.filters={}
                action.payload?.forEach((key:any)=>{
                    if(state?.value?.filters[key]){
                        delete state?.value?.filters[key]
                    }
                })
            }
        }
    }
})

export const { saveDeadManagementFilters,clearFilterDeadManagementFilters } = DeadManagementFiltersSlice.actions

export default DeadManagementFiltersSlice.reducer